import { Box, InputLabel, TextField } from '@mui/material'
import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { createMessage } from '../../../../../actions/messages'
import i18n from '../../../../../lang/idiomas'
/**
 * The SerialNumberFilter component
 * @component
 *
 * @param {Object} props
 * @param {string} props.dateFrom
 * @param {string} props.dateUntil
 * @param {function} props.handleDateFrom
 * @param {function} props.handleDateUntil
 * @returns {JSX.Element}
 */

const DateFilter = ({ handleDateFrom, handleDateUntil }) => {
  const dispatch = useDispatch()
  const [dateFrom, setDateFrom] = useState('')
  const [dateUntil, setDateUntil] = useState('')

  useEffect(() => {
    if (dateFrom && dateUntil && dateUntil < dateFrom) {
      setDateUntil(dateFrom)
      dispatch(createMessage(i18n.t('webpresupuestos.wpdferrf'), 'warning'))
    }
    handleDateFrom(dateFrom)
    handleDateUntil(dateUntil)
  }, [dateFrom, dateUntil])

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        mt: '14px',
      }}>
      <Box
        sx={{
          width: '49.5%',
        }}>
        <InputLabel
          sx={{
            width: '100%',
            color: 'black',
            fontSize: '19px',
            letterSpacing: '0.5px',
          }}
          shrink={true}>
          {i18n.t('webpresupuestos.wpdffd')}
        </InputLabel>
        <TextField
          sx={{ mb: 1 }}
          InputLabelProps={{ shrink: true }}
          InputProps={{ maxLength: 12 }}
          variant='standard'
          value={dateFrom}
          onChange={e => {
            setDateFrom(e.target.value)
          }}
          type={'date'}
          fullWidth
        />
      </Box>
      <Box
        sx={{
          width: '49.5%',
        }}>
        <InputLabel
          sx={{
            width: '100%',
            color: 'black',
            fontSize: '19px',
            letterSpacing: '0.5px',
          }}
          shrink={true}>
          {i18n.t('webpresupuestos.wpdffh')}
        </InputLabel>
        <TextField
          sx={{ mb: 1 }}
          InputLabelProps={{ shrink: true }}
          InputProps={{ maxLength: 12 }}
          variant='standard'
          value={dateUntil}
          onChange={e => {
            setDateUntil(e.target.value)
          }}
          type={'date'}
          fullWidth
        />
      </Box>
    </Box>
  )
}

export default DateFilter
